export default __webpack_public_path__ + "static/media/dormammoo1.a15f0af1.jpg";